/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'cunning',
    quality: 0.3,
    learning: 2,
    magicalGravity: -1.8 
}